import React,{useState,useEffect} from 'react'
import {Navbar, Sidebar,SubSidebar} from "../../components/index"
import { Outlet } from 'react-router-dom'
import '../client/client.css'
import './superadmin.css'
import { useLocation,Navigate ,useParams} from 'react-router-dom'
import {useSelector} from "react-redux"
import Home from "../../assests/home_inactive.png"
import users from "../../assests/users.png"
import active_users from "../../assests/users_active.png"
import Setting from "../../assests/settings.png"
import active_settings from "../../assests/setting_active.png"

import active_Home from "../../assests/home.png"
import gsap from "gsap";


const SuperAdminDashboard = ({navbarRef,sidebar,contentRef}) => {

  const location = useLocation();
  const [tab,setTab]=useState('')
  const user=useSelector((state)=>state?.user)
  const { client_id } = useParams();

  const [isOpenSidebar,setIsOpenSidebar]=useState(false)


  useEffect(()=>{
    
      if(location.pathname.startsWith('/super_admin/clients/') && client_id)
        {
            setTab('user_profile')
        }
        else{
          if(location.pathname.split('/')[2]!="")
            {
                setTab(location.pathname.split('/')[2])
            }
            else{
                setTab(location.pathname.split('/')[1])
  
            }
           

        }
 

  },[location.pathname])

  useEffect(()=>{
  
    gsap.from(sidebar.current, { x: -200, duration: 1.25,opacity:0, ease: "easeIn" });
    gsap.from(navbarRef.current, { y: -200, duration: 1.25,opacity:0, ease: "easeIn" });
    gsap.from(contentRef.current, { y: 500, duration: 1.25,opacity:0, ease: "easeIn" });

  },[])



    const superAdminSidebarOptions = [
        { label: 'Home', path: '', icon_classnames:"bi bi-house", inactive:Home, active:active_Home, enable:true, end: true },
        { label: 'Clients', path: 'clients' ,icon_classnames:"bi bi-people",inactive:users,active:active_users 
          // sub_options:[
          //   {label: 'Active Clients', path: 'clients?status=active' ,icon_classnames:"bi bi-people"},
          //   {label: 'Blocked Clients', path: 'clients?status=blocked' ,icon_classnames:"bi bi-people"}

          // ]
          ,enable:true

        },
        { label: 'Settings', path: 'settings',icon_classnames:"bi bi-gear",inactive:Setting,active:active_settings,  enable:true },
        
      ];
      const superAdminSubSidebarOptions=[
        { label: 'Profile', path:`/super_admin/clients/${client_id}` },
        { label: 'Insights', path:`/super_admin/clients/${client_id}/insights` },
        { label: 'Members', path: `/super_admin/clients/${client_id}/members` },
        { label: 'Programs', path: `/super_admin/clients/${client_id}/programs` },
        { label: 'Campaigns', path: `/super_admin/clients/${client_id}/campaigns` },
        { label: 'Terms & Conditions', path: `/super_admin/clients/${client_id}/terms_and_conditions` }

      ]

      if(!user?.isLoggedIn || !user?.is_super_admin)
        {
          
          return <Navigate to="/super_admin/login" />
      
        }

  return (
  
    <div className="client_main">
      {/* sidebar */}
        <Sidebar sidebar={sidebar} sidebar_options={superAdminSidebarOptions} tab={tab}  isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>
        {location.pathname.startsWith('/super_admin/clients/') && client_id  && <SubSidebar options={superAdminSubSidebarOptions} />}
       
        
  
        {/* <!-- menu --> */}
        <div className="main">
            {/* <!-- navbar --> */}
            <Navbar navbarRef={navbarRef} setIsOpenSidebar={setIsOpenSidebar} />
 
            {/* <!-- content --> */}
            {/* <div className="content"> */}
                <div ref={contentRef} className="content_container padding">
                  <Outlet />

                </div>

            {/* </div> */}

        </div>



    </div>


  )
}

export default SuperAdminDashboard